export default __webpack_public_path__ + "static/media/spin.dc62d977.png";